import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import { Icon, Button, message, Menu, Dropdown } from 'antd'
import ColorPicker from 'rc-color-picker';
import ImageProcessor from './utils/ImageProcessing';
import ImageComponent from './components/image';
import Fade from './animation/Fade';
import { unregister } from './registerServiceWorker';
import ReactGA from 'react-ga';

import Header from './components/header'

import 'rc-color-picker/assets/index.css';
import './styles.css';

ReactGA.initialize('UA-121053599-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {

    constructor() {
        super();
        this.state = {
            files: [],
            globalColor: '#000',
            processed: [],
            type: 'PopSocket'
        }
    }

    onDrop =(files, rejected)=> {
        if(rejected.length > 0) {
            message.warning(`Whoops! Some of your files aren't pngs so we can't process them`)
        }

        // Unable to duplicate a file object later on so Convert File Objects to JSON Object
        let f = files.map(file => ({
            id: Math.random().toString(32),
            name: `${file.name.slice(0, -4)}-${this.state.type}`,
            type: this.state.type,
            preview: file.preview,
            color: this.state.globalColor
        }));

        // If state.files already contains files, add new uploads to existing state.files items
        this.setState({
            files: this.state.files.length > 0 ? [...this.state.files, ...f] : f,
        });
    }

    changeColor(colorObj) {
        const files = this.state.files.map(file => ({
            ...file,
            color: colorObj.color
        }));

        this.setState({
            files: files,
            globalColor: colorObj.color
        })
    }

    deleteFile(i) {
        this.setState({
            files: this.state.files.filter((item, index) => {
                return index !== i;
            }),
        });
    }

    downloadAll() {
        this.setState({
            downloading: true
        })
        ReactGA.event({
            category: 'Download',
            action: 'Download All',
            label: this.state.type
        });
        ImageProcessor.drawAndSavePreLoad(this.state.files, this.state.type, ()=>{
            this.setState({
                downloading: false
            })
        });
    }

    clearAll() {
        this.setState({
            files: [],
            processed: []
        })
    }

    duplicate(i) {
        // Create a copy of the state.files array to avoid mutation
        const arr = this.state.files.map(file => ({...file}));
        let dupeArr = this.state.files[i];
        dupeArr.id = Math.random().toString(32);
        const index = i + 1;

        arr.splice(index, 0, dupeArr);
        this.setState({
            files: arr
        })
    }

    onColorChange = (index ,color) => {
        this.setState({
            files: this.state.files.map((file, i) => {
                if (index !== i) return file;
                return {
                    ...file,
                    color: color ? color : this.state.globalColor,
                };
            }),
        });
    }

    onNameChange = (index, name) => {
        this.setState({
            files: this.state.files.map((file, i) => {
                if (index !== i) return file;
                return {
                    ...file,
                    name,
                };
            }),
        });
    }

    handleMenuClick =(e)=>{
        const oldType = this.state.type;
        this.setState({
            type: e.key,
            files: this.state.files.map((file, i) => {
                return {
                    ...file,
                    name: file.name.replace(new RegExp(oldType,"g"), e.key),
                };
            }),
        });
    }

    render() {
        return (
            <div className="container">
                <Header />
                <div className="content">
                    <Dropzone
                        accept="image/png"
                        className="app-drop"
                        activeClassName="app-drop-active"
                        onDrop={this.onDrop.bind(this)}>
                        <Icon type="upload" style={{ fontSize: 30, color: 'rgb(75, 125, 254)', paddingBottom: 10 }}/>
                        <p>Drag some files here or click to convert</p>
                        <small>All files are stored on your computer. Nothing is uploaded to Merch Resize</small>
                    </Dropzone>
                    <Fade>
                        <div className="menu" style={{visibility: this.state.files.length > 0 ? "visible" : "hidden"}}>

                            <div className="cp-container">
                                {
                                    this.state.type !== "Hoodie" ?
                                        <ColorPicker
                                            className="color-picker"
                                            enableAlpha={false}
                                            animation="slide-up"
                                            color={this.state.globalColor}
                                            onChange={(colorObj) => this.changeColor(colorObj)}
                                        /> : ''
                                }

                            </div>
                            <div className="buttons">
                                <Dropdown overlay={
                                    <Menu onClick={this.handleMenuClick}>
                                        <Menu.Item key="T-Shirt">T-Shirt</Menu.Item>
                                        <Menu.Item key="PopSocket">PopSocket</Menu.Item>
                                        <Menu.Item key="Hoodie">Hoodie</Menu.Item>
                                        <Menu.Item key="iPhone">iPhone Case</Menu.Item>
                                        <Menu.Item key="Samsung">Samsung Case</Menu.Item>
                                        <Menu.Item key="Tote">Tote Bag / Pillow</Menu.Item>
                                        {/*<Menu.Item key="KDP6x9">KDP 6x9</Menu.Item>*/}
                                    </Menu>
                                }>
                                    <Button style={{ marginLeft: 8 }}>
                                        {this.state.type} <Icon type="down" />
                                    </Button>
                                </Dropdown>
                                <Button type="primary" onClick={() => this.downloadAll()}>{this.state.downloading ? <Icon type="loading"> Please Wait..</Icon> : "Download All"}</Button>
                                < Button type="danger" onClick={() => this.clearAll()}>Clear All</Button>
                            </div>
                        </div>
                    </Fade>

                    <div className="app-item-wrapper">
                        {
                            this.state.files.map((f, i) => (
                                <div key={f.id}>
                                    <ImageComponent
                                        file={f}
                                        deleteImage={() => { this.deleteFile(i) }}
                                        duplicate={() => {this.duplicate(i) }}
                                        onColorChange={(color) => this.onColorChange(i, color)}
                                        onNameChange={(name) => this.onNameChange(i, name)}
                                        onRemove={() => this.deleteFile(i)}
                                        type={this.state.type}
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="footer">
                    <span>Copyright © Merch Resize 2021 - Made with <Icon type="heart" /> by <a href="https://github.com/greghesp" target="_blank">Greg</a></span>
                </div>
            </div>

        )
    }
}

unregister();


export default App;



// WEBPACK FOOTER //
// ./src/App.js